<template>
  <div class="formatoDeLaPagina">
    <div class="modal justify-content-center" role="dialog" id="modalDeUrgencia">
      <div v-if="EstaVacioLosDatos(urgencias) == false" class="modal-dialog modal-body modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Mensaje de Poder Judicial del Estado de Aguascalientes</h4>
          </div>
          <div class="modal-body row">
            <div v-for="urgencia in urgencias" :key="urgencia.ContenidoDeLaPaginaWebId" v-bind:class="urgencias.length<=1?'col-lg-12':'col-lg-6'" class="col-md-12">
              <a v-on:click="AbrirDocumento(ObtenLaRutaDeDescarga(urgencia.ArchivosDeContenidoDeLaPaginaWeb), '_self');">
                <img :src="urgencia.RutaDeImagen" />
              </a>
            </div>
            <!--<a href="http://187.189.38.201:85/Files/SICPO/P%C3%A1gina%20Oficial/19/195/2021/Septiembre/2039/2598/Compilado_Ac1_y_aclaratorio.pdf">
            <img src="http://187.189.38.201:85/Files/SICPO/P%C3%A1gina%20Oficial/19/195/2021/Septiembre/2039/Ac.%201.png" />
          </a>-->
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="fa fa-window-close"></i>&nbsp;&nbsp;Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

   



    <!-- Modal -->
    <!-- <div class="modal fade bd-example-modal-lg" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" style="height: 100%;" role="document">
        <div class="modal-content" style="height: 100%;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              <center>
              En colaboración con la Fiscalía Especializada en Combate a la Corrupción, hacemos de tu conocimiento esta información.
            </center></h5>
            <button type="button" class="close" @click="cerrarVideo" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        <div class="modal-body modal-video ">        
          
              <video width="100%" height="100%"  title="YouTube video player" muted controls autoplay>
                <source src="https://themisfsweb.poderjudicialags.gob.mx/VideosInformativos/FECC%20Versio%CC%81n%203.mp4"/>
              </video>
       
          </div>  


          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cerrarVideo">
              <i class="fa fa-window-close"></i>&nbsp;&nbsp;Cerrar
            </button>
          </div>
        </div>
      </div>
    </div> -->

        <div id="landing" class="d-flex justify-content-center">

          <div id="circle-menu">
            <div id="menus-dark" class="dark-bg"></div>
            <div id="menus-gradient" class="dark-gradient"></div>
            <img id="fondo" src="../../../assets/paginaoficial/paginaoficial-martillo.jpg" />
            <img id="logo" src="../../../assets/logo-pj-transparente-blanco.png" />

            <MenuIzquierdo v-on:marcaLaCargaYVerifica="MarcaLaCargaYVerifica"></MenuIzquierdo>
            <MenuDerecho class="d-none d-sm-none d-md-none d-lg-flex d-xlg-flex" v-on:marcaLaCargaYVerifica="MarcaLaCargaYVerifica"></MenuDerecho>
          </div>
        </div>
        <div id="inferior-superior-menu" class="w-100" style="height:28rem; align-items: center; text-align: center; display: flow-root;">
          <a target="_blank" href="https://www.plataformadetransparencia.org.mx/"><img src="https://themisfsweb.poderjudicialags.gob.mx/PJ/op1.jpeg" style="width:15rem; height: 9rem;"></a>
          <a target="_blank" href="https://consultapublicamx.plataformadetransparencia.org.mx/vut-web/?idSujetoObigadoParametro=535&idEntidadParametro=1"><img  src="https://themisfsweb.poderjudicialags.gob.mx/PJ/op4.jpeg" style="width:15rem;height: 9rem;"></a>
        </div>
        <MenuInferior v-on:marcaLaCargaYVerifica="MarcaLaCargaYVerifica"></MenuInferior>
      </div>
</template>

<script>
import enumeraciones from "@/../static/js/enumeraciones";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import api from "@/../static/js/api";
import axios from "axios";
import MenuIzquierdo from "@/components/PaginaOficial/PaginaPrincipal/MenuIzquierda/MenuIzquierda.vue";
import MenuDerecho from "@/components/PaginaOficial/PaginaPrincipal/MenuDerecha.vue";
import MenuInferior from '@/components/PaginaOficial/Comun/MenuInferior.vue';
import comun from "@/../static/js/comun";

export default {
  data() {
    return {
      enumeraciones, 
      enumeraciones_sicpo,
     // urgencia: {},
      urgencias: [],
      TIPO_ROL_DE_ARCHIVO: 1,
      cargoMenuIzquierdo: Number,
      cargoMenuDerecho: Number,
      cargoUrgencia: Number,
      nombreDeVariableDelComponente: "cargoPaginaOficial"
    };
  },
  components: {
    MenuIzquierdo, 
    MenuDerecho,
    MenuInferior
  },
  methods: {

  cerrarVideo:function(){
 
    $("#exampleModalCenter").hide();
  $(".modal-backdrop").hide()
  //$("#exampleModalCenter").modal("hide");
   },
  
    CargarLasUrgencias: function(){
      let parametros = {
        EsPrueba: this.enumeraciones.EsPrueba
      }

      axios
        .post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenLosContenidosDeUrgencia, parametros)
        .then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.error(respuesta.data);
            this.MarcaLaCargaYVerifica("cargoUrgencia", this.enumeraciones_sicpo.EstadosDeCarga.Error);
          } else if (this.EstaVacioLosDatos(respuesta.data.Urgencias) == false) {
            this.urgencias = respuesta.data.Urgencias;
           // console.log("urgencias::",respuesta.data.Urgencias)
            $("#modalDeUrgencia").modal("show");
  $("#exampleModalCenter").modal("show");
 // $("#videoPlayer")[0].play()
          
            this.MarcaLaCargaYVerifica("cargoUrgencia", this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
          } else {
            this.MarcaLaCargaYVerifica("cargoUrgencia", this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
          }
        })
        .catch(excepcion => {
          console.error(excepcion);
          this.MarcaLaCargaYVerifica("cargoUrgencia", this.enumeraciones_sicpo.EstadosDeCarga.Error);
        });
    },


    // CargaLaUrgencia: function(){
    //   let parametros = {
    //     EsPrueba: this.enumeraciones.EsPrueba
    //   }

    //   axios
    //     .post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenElContenidoDeUrgencia, parametros)
    //     .then(respuesta => {
    //       if (respuesta.data.SiHayError) {
    //         console.error(respuesta.data);
    //         this.MarcaLaCargaYVerifica("cargoUrgencia", this.enumeraciones_sicpo.EstadosDeCarga.Error);
    //       } else if (this.EstaVacioLosDatos(respuesta.data.Urgencia) == false) {
    //         this.urgencia = respuesta.data.Urgencia;
    //         $("#modalDeUrgencia").modal("show");
    //         this.MarcaLaCargaYVerifica("cargoUrgencia", this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
    //       } else {
    //         this.MarcaLaCargaYVerifica("cargoUrgencia", this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
    //       }
    //     })
    //     .catch(excepcion => {
    //       console.error(excepcion);
    //       this.MarcaLaCargaYVerifica("cargoUrgencia", this.enumeraciones_sicpo.EstadosDeCarga.Error);
    //     });
    // },
    EstaVacioLosDatos: function(objeto) {
      return objeto === undefined || objeto === null || Object.keys(objeto).length === 0 ? true : false;
    }, 
    ObtenLaRutaDeDescarga: function(archivos) {
      let rutaDeDescarga = "";

      if(archivos != null && archivos != undefined && archivos.length > 0)
        archivos.forEach(archivo => {
          if(this.TIPO_ROL_DE_ARCHIVO == archivo.TipoRolDeArchivoEnContenido.TipoRolDeArchivoEnContenidoId)
         // console.log("ruta del archivo::::",archivo)
            rutaDeDescarga = archivo.RutaDeArchivoCarpeta;
        });

      return rutaDeDescarga;
    },
    AbrirDocumento: function(vinculo, formaDeApertura) {
      //console.log(vinculo)
      comun.DescargarDocumentoPDF(vinculo);
      //window.open(vinculo, formaDeApertura);
    },
    MarcaLaCargaYVerifica: function(nombreDeLaVariable, estatus) {
      this[nombreDeLaVariable] = estatus;

      this.VerificaQueHayaFinalizadoTodaLaCarga();
    }, 
    VerificaQueHayaFinalizadoTodaLaCarga: function() {
      if(this.cargoMenuIzquierdo === this.enumeraciones_sicpo.EstadosDeCarga.Error || 
        this.cargoMenuDerecho === this.enumeraciones_sicpo.EstadosDeCarga.Error || 
        this.cargoUrgencia === this.enumeraciones_sicpo.EstadosDeCarga.Error) {
        this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Error);
      } else if(this.cargoMenuIzquierdo === this.enumeraciones_sicpo.EstadosDeCarga.Cargado && 
        this.cargoMenuDerecho === this.enumeraciones_sicpo.EstadosDeCarga.Cargado && 
        this.cargoUrgencia === this.enumeraciones_sicpo.EstadosDeCarga.Cargado) {
        this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
      } else {
        this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargando);
      }
    }
  },
  mounted() {
    this.cargoMenuIzquierdo = this.enumeraciones_sicpo.EstadosDeCarga.Cargando;
    this.cargoMenuDerecho = this.enumeraciones_sicpo.EstadosDeCarga.Cargando;
    this.cargoUrgencia = this.enumeraciones_sicpo.EstadosDeCarga.Cargando;
    this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargando);
    this.CargarLasUrgencias();
  
  }
};
</script>

<style scoped>
  .modal-video {
    
    background-color: darkgray;
  }
  .bd-example-modal-lg{
    
  }


  ::-webkit-scrollbar {
    width: 10px;
  }

/* Track */
::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.95);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.95);
}

/*#region Classes*/
.render {
  display: none;
}

.btn-primary {
  background-color: #be9a5e;
}

.hide {
  opacity: 0;
}

.dark-bg {
  background: rgba(0, 0, 0, 1);
}

.dark-gradient {
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.95) 12%,
    rgba(0, 0, 0, 0.25) 20%,
    rgba(0, 0, 0, 0.25) 80%,
    rgba(0, 0, 0, 0.95) 88%
  );
}

.clear-gradient {
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.95) 12%,
    rgba(0, 0, 0, 0.2) 20%,
    rgba(0, 0, 0, 0.2) 80%,
    rgba(0, 0, 0, 0.95) 88%
  );
}

.hidden-logo {
  width: 0;
}

.hide-menu {
  opacity: 0;
  width: 0;
  height: 0;
}

#menus-gradient {
  position: absolute;
  /*z-index: 1;*/
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transition: all 1.5s;
}

.formatoDeLaPagina {
  overflow: hidden;
  z-index: 10 !important;
}

#inferior-superior-menu {
    display: flex;
    height: 65px;
    min-height: 30px;
    max-height: 9rem;
    background-color: rgb(255, 255, 255);
    /* z-index: 10 !important; */
    position: relative;
}
/*#endregion*/

/*#region FullSize*/
.modal-title {
  color: white;
}

#circle-menu {
  height: calc(100vh - 103px);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  position: relative;
}

#logo {
  z-index: 3;
  transition: all 3s;
  width: 20%;
  position: absolute;
}

h2 {
  font-size: 1em;
  margin-bottom: 0;
}

.btn {
  color: #fff;
}

.dropdown-toggle::after {
  display: none;
}
#fondo{
  height: 90vh;
  /* src: "../../../assets/paginaoficial/paginaoficial-martillo.jpg"; */
}

#landing {
  /* background-image: url("../../../assets/paginaoficial/paginaoficial-martillo.jpg"); */
/* 
  background-size: cover;
  background-repeat: no-repeat; */
  color: #fff;
  min-height: calc(100vh - 103px);
}

@media (max-width: 1600px) {

}

@media (max-width: 1200px) {

}

@media (max-width: 1024px) {
  #landing {
    background-image: none;
    background-color: #000;
  }

  #circle-menu {
    height: calc(100vh - 103px);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100vw;
    position: relative;
  }

  #logo {
    display: block;
    margin-top: 35vh;
  }
}

@media (max-width: 768px) {
  #logo {
    display: block;
    margin-top: 38vh;
  }
  #fondo{
  display: none;
  }
}

@media (max-width: 600px) {

}

@media(max-width: 1024px){
   #fondo{
  display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaPrincipal/Index.vue